import React from "react";
import styled from "styled-components";
import { ReactComponent as FirmLogo } from "src/assets/logo.svg";
import { ReactComponent as CollapsedLogo } from "src/assets/collapsedLogo.svg";

/**
 * The rail's top row.
 *
 * 64px tall, which is football's rail header — the box here was 152px, more
 * than twice that, so the logo sat in a tall empty panel and pushed the whole
 * navigation down the rail.
 *
 * Sized by HEIGHT rather than width. The two marks have opposite proportions
 * — the wordmark is 563x138 and the collapsed mark 66x72, one four times wider
 * than tall and the other slightly taller than wide — so a width cap made
 * them visually different sizes, and letting flexbox size the 563px artwork
 * stretched it edge to edge. A height cap makes the two read as the same
 * logo at the same scale in either state.
 *
 * Expanded, it starts at the rail's lead edge like football's identity row
 * rather than being centred, so it lines up with the nav rows beneath it.
 */
const Container = styled.a<{ $isCollapsed: boolean }>`
  display: flex;
  flex: none;
  height: 64px;
  align-items: center;
  justify-content: ${({ $isCollapsed }) =>
    $isCollapsed ? "center" : "flex-start"};
  box-sizing: border-box;
  padding: ${({ $isCollapsed }) => ($isCollapsed ? "0" : "0 14px 0 16px")};
  overflow: hidden;

  svg {
    flex: none;
    width: auto;
    height: ${({ $isCollapsed }) => ($isCollapsed ? "30px" : "32px")};
    max-width: 100%;
  }
`;

const Logo: React.FC<{ isCollapsed: boolean }> = ({ isCollapsed }) => {
  return (
    <Container $isCollapsed={isCollapsed}>
      {isCollapsed ? <CollapsedLogo /> : <FirmLogo />}
    </Container>
  );
};

export default Logo;
